import { render, staticRenderFns } from "./PanelAdminsPage.vue?vue&type=template&id=52293fa3&"
import script from "./PanelAdminsPage.vue?vue&type=script&lang=js&"
export * from "./PanelAdminsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports